import React from 'react';
import styles from '$styles/ind/home/footer.module.scss';
import { defaultFooterProps } from './footerConfig';

export interface IFooterProps {
  isMobile?: boolean;
  isDesktop?: boolean;
}

const AppFooter: React.FC<IFooterProps> = () => {
  const { footerLinks, rbLogoUrl, aboutUsContent, copyrightText, socialProfiles } = defaultFooterProps;

  return (
    <footer className={styles.footerContainer} data-autoid="footer">
      <div className={styles.footer}>
        <div className={styles.linksContainer}>
          {footerLinks.map((footerLink, columnIndex) => (
            <div className={styles.linkContainer} key={footerLink.title + columnIndex}>
              <h4 className={styles.title}>{footerLink.title}</h4>
              <div
                className={styles.linksWrapper}
                role="list"
                aria-label={`${footerLink.title} links`}
              >
                {footerLink.listItems.map((item, itemIndex) => (
                  <span key={item.displayName + itemIndex} role="listitem">
                    <a
                      className={styles.linkButton}
                      href={item.redirectUrl}
                      target="_blank"
                      rel={item.noFollow ?? 'noopener noreferrer'}
                    >
                      {item.displayName}
                    </a>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className={styles.aboutUs}>
          <img
            className={styles.rbLogo}
            src={rbLogoUrl}
            loading="lazy"
            width={66}
            height={42}
            alt="Red bus logo"
          />
          <span className={styles.content}>{aboutUsContent}</span>
        </div>
        <div className={styles.bottomSection}>
          <span className={styles.copyright}>{copyrightText}</span>
          <div className={styles.socialProfiles} role="list" aria-label="Social Profiles">
            {socialProfiles.map((social) => (
              <span key={social.key} role="listitem">
                <a
                  href={social.redirectionUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.key}
                  role="link"
                >
                  <img
                    className={styles.social}
                    src={social.imgUrl}
                    loading="lazy"
                    width={32}
                    height={32}
                    alt=""
                    decoding="async"
                  />
                </a>
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
